/**
 * Visit-count copy for check-in history rows.
 *
 * @example formatVisitCount(1) // '1 visit'
 * @example formatVisitCount(3) // '3 visits'
 */
export const formatVisitCount = (count) => `${count} ${count === 1 ? 'visit' : 'visits'}`;
/**
 * Visit number as an ordinal, for the check-in confirmation.
 * @example formatVisitOrdinal(3) // '3rd visit'
 * @example formatVisitOrdinal(12) // '12th visit'
 */
export const formatVisitOrdinal = (count) => {
    const lastTwo = count % 100;
    const suffix = lastTwo >= 11 && lastTwo <= 13
        ? 'th'
        : ({ 1: 'st', 2: 'nd', 3: 'rd' }[count % 10] ?? 'th');
    return `${count}${suffix} visit`;
};
